import { RootPlugs, ScheduleTreeBar } from "slot-definitions"
import { createEvent } from "library/local-events/index.mjs"
import { ActivityDrawer } from "routes/audit/component/activity-drawer"
import { Activity } from "routes/audit/component/activity-button"
import { auditsForPublishedSchedules } from "./audits-for-published-schedules"
import { isInRegime } from "routes/facilities/lib/when-parent-item"

ScheduleTreeBar.plug(({ context }) => {
    if (!showActivityButton(context)) return null
    return (
        <Activity
            type={"customSchedule"}
            fileNamePrefix={context.schedule.title}
            filterFn={auditsForPublishedSchedules}
            priority={250}
            title={context.activityTitle}
        />
    )
})

function showActivityButton(params) {
    const isCustom = params?.schedule?.type?.Name === "Custom"
    const isNotShareLink = !params.isShare
    const inRegime = isInRegime(params)
    return !!isCustom && !!isNotShareLink && !inRegime
}

RootPlugs.plug(<ActivityDrawer />)

export const ShowActivity = createEvent("ShowActivity")
